import React from 'react';

import Footer from '../../../components/Footer';
import Header from '../../../components/Header';

import { Wrapper } from './styles';

const DefaultLayout = ({ children }) => {
  return (
    <Wrapper>
      <Header/>
      {children}
      <Footer />
    </Wrapper>
  );
}

export default DefaultLayout;